import { render } from "./StepWizardUpdate3.vue?vue&type=template&id=4ae9060a"
import script from "./StepWizardUpdate3.vue?vue&type=script&lang=js"
export * from "./StepWizardUpdate3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__